import React, { Component } from 'react';
import './text.css';

class Text extends Component {
	constructor(props) {
		super(props);
		this.load = this.load.bind( this );
		
		this.state = {
			"title": null,
			"text": null,
			"visible": false
		}
	}
	
	componentDidMount() {
		this.load();
	}
	
	componentDidUpdate( prevProps, prevState ) {
		if ( prevProps.Location !== this.props.Location && this.props.Location.indexOf('/leggi/') > -1 ) {
			this.load();
		} else if ( prevProps.Location !== this.props.Location && prevState.visible === true ) {
			this.setState( { "visible": false, "body": null, "title":null } );
		}
	}
	
	load() {
		var location = process.env.PUBLIC_URL + this.props.Location.replace(/#/ig,'') + '.json';
		if ( location ) {
			this.props.FetchContent(
				location,
				{},
				(data) => {
					if ( data.error ) {
						console.log( data.errormessage );
						window.location.hash = '/leggi/errore';
					} else {
						this.setState( { "title": data.title, "text": data.text, "visible": true } );
						this.props.SetTitle( data.title );
						this.props.ShowLoading( false );
					}
				},
				(error) => {
					console.log( error );
					window.location.hash = '/leggi/errore';
				}
			);
		}
	}
  
  
  
	render() {
		if ( this.state.visible ) {
			return (
				<div className="text">
		
					<h1 className="text-title">{this.state.title}</h1>
					
					<div className="text-body" dangerouslySetInnerHTML={{__html: this.state.text}}></div>
		
				</div>
			);
		} else {
			return null;
		}
	}
}

export default Text;



// WEBPACK FOOTER //
// ./src/Elezioni/text.js